import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const requestLogService = {
    getAll,
};

const MODULE = {
    REQUEST_LOG: 'request-logs',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            // exclude_request_logs: filter?.excludeRequestLogs,
            path_prefix: filter?.pathPrefix,
            method: filter?.method,
            success: filter?.success,
            user: filter?.user,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.REQUEST_LOG}`, request);
}